module.exports = __webpack_public_path__ + "img/68.6.CODm.a3b655a5.png";